import Resource from "./Resource";

/**
 * Time Card Resource
 */
class TimeCard extends Resource
{
    constructor() {
        super('time.card', ['time-cards']);
    }

    options(params) {
        return this._doGet(['options'], params);
    }
}
export let TimeCardResource = new TimeCard();

/**
 * Time Card Schema
 */
export let TimeCardSchema = function(defaults = {}) {
    let schema = {
        minutes: null,
        description: null,
        user_id: null,
        task_id: null,
        card_date: new Date,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}